// mixin.js
import { ProductTemplate } from '@/assets/interface/Product';
import { ProductInfo } from '@luxtag/papybase';
import Vue from 'vue';
import Component from 'vue-class-component';


// You can declare a mixin as the same style as components.
@Component
export default class InterfaceTranslatorMixin extends Vue {
    public translateProductInfoToProductTemplate(productInfo: ProductInfo) {
        const template: ProductTemplate = {
            productTemplate: productInfo.productTemplate,
            id: productInfo.id,
            name: JSON.parse(productInfo.name),
            sku: JSON.parse(productInfo.sku),
            fields: JSON.parse(productInfo.fields),
            images: JSON.parse(productInfo.image_url),
            description: JSON.parse(productInfo.description),
            created: productInfo.createdAt,
            updated: productInfo.updatedAt,
        };
        return template;
    }
}
